import { CustomButton } from 'Components/Auth/CustomButton';
import { TextInput } from 'Components/Auth/TextInput';
import Form from 'Components/Form';
import DateInput from 'Components/Form/DateInput';
import { MaskedInput } from 'Components/Form/MaskedInput';
import * as React from 'react';
import { SubmitHandler } from 'react-hook-form';
import * as Yup from 'yup';
import { ProfileUser } from '../../editPersonalDetails';

import { useGetClientProfile } from 'admin/features/clients/viewClientDetails/accountInfoClientTab';
import { useUpdateClient } from 'app/features/profile/accountInfo/editAccountInfo';
import { errorToast, successToast } from 'Components/Notifications';
import Spinner from 'Components/Spinner';

export interface IPersonalStepProps {}
export type FormInputs = {
  ssn: string;
  birth_date: string;
  occupation: string;
};

export const validationSchema = Yup.object().shape({
  ssn: Yup.string().trim().required('required'),
  birth_date: Yup.string().trim().required('required'),
  occupation: Yup.string().trim().required('required'),
});

export default function PersonalStep(props: IPersonalStepProps) {
  const { UpdateClient } = useUpdateClient();

  const { client } = useGetClientProfile();

  let { setActiveStep } = React.useContext(ProfileUser);
  if (!client) return <Spinner />;

  let initialData: FormInputs = {
    ssn: client.ssn ? client.ssn : '',
    birth_date: client.birth_date ? client.birth_date : '',
    occupation: client.occupation ? client.occupation : '',
  };
  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    try {
      await UpdateClient(data).then(async () => {
        await successToast('Personal Information Updated Successfully');
        setActiveStep('Spouse');
      });
    } catch (error: any) {
      errorToast(error);
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      defaultValues={initialData}
      validationSchema={validationSchema}
    >
      {() => (
        <>
          <div className="flex w-full mb-3">
            <div className="w-1/3   md-max:w-full">
              <MaskedInput
                name="ssn"
                label="Social Security Number"
                mask="999-99-9999"
                type="maskedInput"
                placeholder="SSN"
              />
            </div>
          </div>
          <div className="flex w-full mb-3">
            <div className="w-1/3   md-max:w-full normal-case	">
              <DateInput
                name="birth_date"
                type={'date'}
                placeholder={'mm/dd/yyyy'}
                label="Date of Birth"
              />
            </div>
          </div>
          <div className="flex w-full mb-3">
            <div className="w-1/3 md-max:w-full">
              <TextInput
                name="occupation"
                label="Occupation"
                placeholder="Occupation"
                type="text"
                rules={{ required: 'required' }}
              />
            </div>
          </div>

          <div className="w-1/6 flex flex-inline gap-4 mt-6  md-max:w-full">
            <CustomButton type="submit" text="Save & Continue" />
          </div>
        </>
      )}
    </Form>
  );
}
